<template>
    <div class="foreignHandicap-box" v-if="indexData1.length||indexData2.length||indexData3.length||indexData4.length">
        <div class="left">
            <!-- 外汇名称 -->
            <div class="title title_color">{{indexData1[3]}}</div>
            <!-- 外汇代码 -->
            <div class="title_color">{{indexData4[2]}}</div>
        </div>
        <div class="center">
            <div class="title">成交价{{deal}}</div>
            <div class="center-info">
                <div class="center-info-left">
                    <!-- 最新价 -->
                    <div class="max-text" :style="{color:indexData3[9]>indexData3[6]?'#EF4342':'#2ab447'}">
                        <span :class="[{'bg-red':last_px==1},{'bg-green':last_px==2},{'bg-none':last_px==0}]">
                            <span>{{indexData3[5]|priceIntFormat}}</span>
                            <span>{{indexData3[5]|priceDecFormat}}</span>
                        </span>
                    </div>
                    <div class="change-precent">
                        <!-- 涨跌额 -->
                        <span :class="[indexData3[9]>0?'up':'down']" :style="{color:indexData3[9]==0?'#333':''}"> {{indexData3[9]}} </span>
                        <!-- 涨跌幅 -->
                        <span :class="[indexData3[9]>0?'up':'down']" :style="{color:indexData3[9]==0?'#333':''}"> {{indexData3[10]+'%'}}</span>
                    </div>
                    <div class="date_color">{{indexData3[11]|dateFormat}} {{indexData3[0]|timeFormat}}</div>
                </div>
                <ul class="center-info-right">
                    <li><span class="space_9">开</span>盘
                        <span class="date_color">({{indexData3[12]|timeFormat}})</span>
                        <span class="padding_l_5">{{indexData3[2]==0?'--':indexData3[2]}}</span>
                    </li>
                    <li><span class="space_9">最</span>高
                        <span class="date_color">({{indexData3[13]|timeFormat}})</span>
                        <span class="padding_l_5">{{indexData3[3]==0?'--':indexData3[3]}}</span>
                    </li>
                    <li><span class="space_9">最</span>低
                        <span class="date_color">({{indexData3[14]|timeFormat}})</span>
                        <span class="padding_l_5">{{indexData3[4]==0?'--':indexData3[4]}}</span>
                    </li>
                    <li v-if="type_code==type_list[1]||type_code==type_list[2]">
                        <span class="space_15">中间价</span><span class="padding_l_10">{{indexData1[2]==0?'--':indexData1[2]}}</span>
                    </li>
                    <li v-if="type_code==type_list[5]">
                        <span style="letter-spacing:5px">最新远期点</span><span class="padding_l_5">{{last_px_forward}}</span>
                    </li>
                    <li><span class="space_9">上收盘价</span><span class="padding_l_5">{{indexData3[6]==0?'--':indexData3[6]}}</span></li>
                    <li><span class="space_9">上收盘日</span><span class="padding_l_5">{{indexData3[7]==0?'--':indexData3[7]|dateFormat}}</span></li>
                    <li v-if="type_code==type_list[1]||type_code==type_list[2]">
                        <span>收盘价</span><span class="date_color">(16:30)</span>
                        <span class="padding_l_5">{{indexData3[8]==0?'--':indexData3[8]}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="line"></div>
        <!-- 最优报价部分 -->
        <div class="right" v-if="isMany">
            <div class="title">最优报价{{offer}}</div>
            <ul class="right-info">
                <li class="date_color"><span>买价({{quotedPriceTime[1]|timeFormat}})</span></li>
                <li class="date_color"><span>卖价({{quotedPriceTime[1]|timeFormat}})</span></li>
                <li class="max-text" :style="{color:indexData3[9]>indexData3[6]?'#EF4342':'#2ab447'}">
                    <span :class="[{'bg-red':last_px1==1},{'bg-green':last_px1==2},{'bg-none':last_px1==0}]">
                        <span>{{quotedPrice[0]|priceIntFormat}}</span>
                        <span>{{quotedPrice[0]|priceDecFormat}}</span>
                    </span>
                </li>
                <li class="max-text" :style="{color:indexData3[9]>indexData3[6]?'#EF4342':'#2ab447'}">
                    <span :class="[{'bg-red':last_px2==1},{'bg-green':last_px2==2},{'bg-none':last_px2==0}]">
                        <span>{{quotedPrice[1]|priceIntFormat}}</span>
                        <span>{{quotedPrice[1]|priceDecFormat}}</span>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "handicapExchange",
    props: {
        // 板块
        prod_code: {
            type: String,
            default: ""
        },
        // 请求间隔
        throttle: {
            type: Number,
            default: 3000
        }
    },
    data() {
        return {
            timer: null,
            quotedPrice: [], //多业务报价
            quotedPriceTime: [], // 多业务报价时间
            last_px_forward: 0, // 最新远期点
            isMany: true, // 是否多业务
            isInquiry: false, // 是否询价
            type_code: '', // 类型代码
            prod_code1: "", // 中间价
            prod_code2: "", // 报价
            prod_code3: "", //成交
            indexData1: [], // 中间价
            indexData2: [], // 报价
            indexData3: [], // 成交价
            indexData4: [], // 货币对中文名
            fields: "prod_name,hq_type_code,business_type",  // 0、板块
            fields1: "last_px,money_type,",  // 1、中间价
            fields2: "business_data_grp,market_date", // 2、报价
            fields3: [ // 3、成交价
				"open_px", // 2开
                "high_px", // 3高
				"low_px", // 4低
				"last_px", // 5最新价
				"preclose_px", // 6昨收
				"business_last_closedate", // 7上收盘日
				"special_close_px", // 8特殊收盘价 16:30收盘价
				"px_change", // 9涨跌额
                "px_change_rate", // 10涨跌幅
                'market_date', // 11市场日期
                'open_timestamp', // 12开盘时间
                'high_timestamp', // 13高价时间
                'low_timestamp' // 14低价时间
            ],
            type_list: [
                'XBFX',
                'XBFX.SPOT.CNY', // 人民币外汇即期询价
                'XBFX.SPOT.ODM', // 人民币外汇即期撮合
                'XBFX.SWAP.CNY', // 人民币外汇掉期询价
                'XBFX.CSWAP.CNY', // 人民币外汇掉期撮合
                'XBFX.FWD.CNY', // 人民币外汇远期
                'XBFX.SPOT.FXB', // 外币对外汇即期询价
                'XBFX.SPOT.FXA' // 外币对外汇即期竞价
            ],
            fields4: "prod_name", // 货币对中文名
            last_px: 0,
            last_px1: 0,
            last_px2: 0,
            deal: '', // 成交后缀
            offer: '' // 报价后缀
        }
    },
    created() {
        this.getIndexDataInterval0(this.prod_code)
    },
    methods: {
        // 板块查询
        getIndexDataInterval0(code) {
            this.OpenAPI.block_elements(code).then(res => {
                let prod_code = res.data.block_elements[code]
                let type_code = res.data.block_elements.hq_type_code
                this.type_code = type_code
                let list = this.type_list
                // 行情参数获取
                prod_code.map((ele) => {
                    if (ele[3] === 3) { // 中间价
                        this.prod_code1 = ele[0] + '.' + ele[2].split('.')[0]
                    } else if(ele[3] === 2) { //  报价
                        this.prod_code2 = ele[0] + '.' + ele[2].split('.')[0]
                    } else if(ele[3] === 1) { // 成交价
                        this.prod_code3 = ele[0] + '.' + ele[2].split('.')[0]
                    }
                })
                // 板块类型-成交部分
                if (type_code === list[3] || type_code === list[5] || type_code === list[6]) {
                    this.deal = '（询价）'
                } else if (type_code === list[4]) {
                    this.deal = '（撮合）'
                } else if (type_code === list[7]) {
                    this.deal = '（竞价）'
                }
                // 板块类型-报价部分
                if (type_code === list[1] || type_code === list[3] || type_code === list[6]) {
                    this.offer = '（询价）'
                } else if (type_code === list[2] || type_code === list[4]) {
                    this.offer = '（撮合）'
                }
                // 是否有报价部分
                if (type_code === list[5] || type_code === list[7]) {
                    this.isMany = false
                }

            }).then(() => {
                this.getOtherData()
            });
        },
        // 根据板块code其他查询
        getOtherData() {
            this.getIndexDataInterval()
            if (this.throttle > 0) {
                this.timer = setInterval(() => {
                    this.getIndexDataInterval()
                }, 10000);
            }
        },
        getIndexDataInterval() {
            Promise.all([
                // 中间价
                (() => {
                    let [code, fields] = [this.prod_code1, this.fields1]
                    let params = { code, fields };
                    this.OpenAPI.real(params).then(res => {
                        this.indexData1 = res[code];
                    });
                })(),
                // 报价
                (() => {
                    let [code, fields] = [this.prod_code2, this.fields2]
                    let params = { code, fields };
                    this.OpenAPI.real(params).then(res => {
                        this.indexData2 = res[code];
                    });
                })(),
                // 成交价
                (() => {
                    let [code, fields] = [this.prod_code3, this.fields3]
                    let params = { code, fields };
                    this.OpenAPI.real(params).then(res => {
                        this.indexData3 = res[code];
                    });
                })(),
                // 中文名
                (() => {
                    let [code, fields] = [this.prod_code, this.fields]
                    let params = { code, fields };
                    this.OpenAPI.real(params).then(res => {
                        this.indexData4 = res[code];
                    });
                })()
            ])
        }
    },
    filters: {
        // 全局过滤器
        // dateFormat日期
        // timeFormat时间
        // priceIntFormat价格前部分
        // priceDecFormat价格后部分
    },
    watch: {
        indexData2: { // 报价
            handler(newVal, oldVal) {
                if (newVal[2]) {
                    this.quotedPrice = []
                    this.quotedPrice.push(newVal[2][2]['last_px'])
                    this.quotedPrice.push(newVal[2][3]['last_px'])
                    this.quotedPriceTime.push(newVal[2][2]['market_date'])
                    this.quotedPriceTime.push(newVal[2][2]['data_timestamp'])
                } else {
                    this.last_px_forward = newVal[2][0]['last_px']
                    this.isMany = false
                }
            },
            inmediate: true,
            deep: true
        },
        indexData3: { // 成交价
            handler(newVal, oldVal) {
                let timeout = 2000
                if (newVal[5] > oldVal[5]) { // 最新价
                    this.last_px = 1
                } else if (newVal[5] < oldVal[5]) {
                    this.last_px = 2
                }
                setTimeout(() => {
                    this.last_px = 0
                }, timeout);

            },
            inmediate: true,
            deep: true
        },
        quotedPrice: { // 报价缓存
            handler(newVal, oldVal) {
                // 背景颜色
                let timeout = 2000
                if (newVal[0] > oldVal[0]) { // 买价
                    this.last_px1 = 1
                } else if (newVal[0] < oldVal[0]) {
                    this.last_px1 = 2
                }
                if (newVal[1] > oldVal[1]) { // 卖价
                    this.last_px2 = 1
                } else if (newVal[1] < oldVal[1]) {
                    this.last_px2 = 2
                }
                setTimeout(() => {
                    this.last_px1 = 0
                    this.last_px2 = 0
                }, timeout);
            },
            inmediate: true,
            deep: true
        }
    },
    destroyed() {
        clearInterval(this.timer)
    }
}
</script>
<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  font-size: 14px;
  list-style-type: none;
}
$box_height: 105px;
.foreignHandicap-box {
    color: #333;
    min-width: 1024px;
    overflow: 0 auto;
    width: 100%;
    height: $box_height;
    display: flex;
    text-align: center;
    box-shadow: 0 0 10px #D6D6D6;
    .left {
        width: 20%;
        background: #e8f1ff;
        >div {
            line-height: $box_height/2;
            font-weight: bold;
        }
        .title {
            font-size: 18px;
        }
    }
    .center {
        flex: 1;
        line-height: $box_height/4;
        .title{
            font-size: 16px;
            color: #999;
        }
        .center-info {
            display: flex;
            .center-info-left {
                width: 20%;
                float: left;
                display: flex;
                flex-wrap: wrap;
                top: -20px;
                position: relative;
                >div {
                    width: 100%;
                    &:first-child {
                        line-height: 40px;
                    }
                    &:last-child {
                        font-size: 12px;
                    }
                }
                .max-text {
                    color: #ef4342;
                    position: relative;
                    font-weight: bold;
                    >span {
                        padding: 0 10px;
                        border-radius: 3px;
                    }
                    span {
                        &:first-child {
                            font-size: 24px;
                            margin-right: -5px;
                        }
                        &:last-child {
                            font-size: 32px;
                        }
                    }
                }
                .change-precent {
                    .up {
                        color: #ef4342;
                    }
                    .down {
                        color: #2ab447;
                    }
                    span {
                        padding: 0 5px;
                    }
                }
            }
            .center-info-right {
                flex: 1;
                float: right;
                display: flex;
                flex-wrap: wrap;
                height: 75px;
                li {
                    width: 33%;
                    text-align: left;
                }
            }
        }
    }
    .line {
        width: 1px;
        border-left: 1px solid #D6D6D6;
        height: ($box_height)-30;
        position: relative;
        top: 15px;
    }
    .right {
        width: 20%;
        >div {
            line-height: $box_height/4;
        }
        .title{
            font-size: 16px;
            color: #999;
        }
        .right-info{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li {
                line-height: ($box_height/3)-5;
                width: 50%;
                font-size: 12px;
            }
            .max-text {
                font-weight: bold;
                color: #ef4342;
                >span {
                    padding: 10px;
                    border-radius: 3px;
                span {
                    &:first-child {
                        font-size: 20px;
                    }
                    &:last-child {
                        font-size: 26px;
                    }
                }
                }
            }
        }
    }
}
  .bg-red {
    // background: #F9D9E4;
    background: rgb(255,253,215);
  }
  .bg-green {
    // background: #D3F5D4;
    background: rgb(255,253,215);
  }
  .bg-none {
    background-color: white;
  }
  .space_9 {
      letter-spacing: 9px;
  }
  .space_15 {
    letter-spacing: 15px;
  }
  .padding_l_5 {
    padding-left: 5px;
  }
   .padding_l_10 {
    padding-left: 10px;
  }
  .date_color {
    color: #666;
  }
  .title_color {
    color: #333;
  }
</style>
